export default function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}


//////////////////
// WEBPACK FOOTER
// /Users/cully/projects/Jobs/abound/~/@babel/runtime/helpers/esm/assertThisInitialized.js
// module id = ../../node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
// module chunks = 18